export default __webpack_public_path__ + "static/media/metamask.e072fe55.png";